<template>
    <div class="layout-full-page">
        <div class="layout-full-page__header">
            <CompassLogo type="logo" :width="118" />
            <CompassBackForwardButton
                :label="$t.__('common.actions.back')"
                :link="backLink"
                type="secondary"
                :back="true"
            />
        </div>
        <div class="layout-full-page__content">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        backLink: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.layout-full-page {
    padding: var(--spacing-1);
    &__header {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);
        margin-bottom: 48px;
    }
    &__content {
        margin: auto;
        width: 760px;
    }
}
</style>
